<section class="py-24 bg-white">
  <div class="container mx-auto px-6">
    
    <!-- Section Title -->
    <div class="text-center max-w-3xl mx-auto mb-20 space-y-4">
      <div class="inline-flex items-center gap-2 bg-indigo-50 text-indigo-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider">
        <i class="fa-solid fa-list-check"></i>
        <span>Simple 3-Step Onboarding</span>
      </div>
      <h2 class="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
        How to Start Teaching on Learnbird
      </h2>
      <p class="text-lg text-slate-600 leading-relaxed">
        From account creation to hosting your first live class, our streamlined process takes only minutes.
      </p>
    </div>

    <!-- Steps Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
      
      <!-- Step 1 -->
      <div class="relative bg-slate-50 border border-slate-200/80 rounded-3xl p-8 space-y-6">
        <div class="flex items-center justify-between">
          <div class="w-14 h-14 rounded-2xl bg-blue-600 text-white font-extrabold text-2xl flex items-center justify-center shadow-lg shadow-blue-500/30">
            1
          </div>
          <span class="daisy-badge daisy-badge-ghost text-xs text-slate-500 font-semibold">Step One</span>
        </div>

        <div class="space-y-3">
          <h3 class="text-xl font-bold text-slate-900">Register as an Instructor</h3>
          <p class="text-slate-600 text-sm leading-relaxed">
            Create your instructor account, complete your basic profile, and select your teaching subjects (O/L, A/L, languages, or professional skills).
          </p>
        </div>

        <div class="pt-4 border-t border-slate-200/60 flex items-center text-xs text-slate-500 gap-2">
          <i class="fa-solid fa-user-plus text-blue-500"></i>
          <span>Instant registration in 2 minutes</span>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="relative bg-slate-50 border border-slate-200/80 rounded-3xl p-8 space-y-6">
        <div class="flex items-center justify-between">
          <div class="w-14 h-14 rounded-2xl bg-indigo-600 text-white font-extrabold text-2xl flex items-center justify-center shadow-lg shadow-indigo-500/30">
            2
          </div>
          <span class="daisy-badge daisy-badge-ghost text-xs text-slate-500 font-semibold">Step Two</span>
        </div>

        <div class="space-y-3">
          <h3 class="text-xl font-bold text-slate-900">Configure Classes & Pricing</h3>
          <p class="text-slate-600 text-sm leading-relaxed">
            Schedule recurring live class sessions or upload course playlists. Set your monthly subscription or single course fee with ease.
          </p>
        </div>

        <div class="pt-4 border-t border-slate-200/60 flex items-center text-xs text-slate-500 gap-2">
          <i class="fa-solid fa-gear text-indigo-500"></i>
          <span>Full pricing control & flexibility</span>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="relative bg-slate-50 border border-slate-200/80 rounded-3xl p-8 space-y-6">
        <div class="flex items-center justify-between">
          <div class="w-14 h-14 rounded-2xl bg-emerald-600 text-white font-extrabold text-2xl flex items-center justify-center shadow-lg shadow-emerald-500/30">
            3
          </div>
          <span class="daisy-badge daisy-badge-ghost text-xs text-slate-500 font-semibold">Step Three</span>
        </div>

        <div class="space-y-3">
          <h3 class="text-xl font-bold text-slate-900">Engage Students & Earn</h3>
          <p class="text-slate-600 text-sm leading-relaxed">
            Host live Zoom lectures, distribute study materials, interact via WhatsApp/Telegram communities, and receive automatic monthly payouts.
          </p>
        </div>

        <div class="pt-4 border-t border-slate-200/60 flex items-center text-xs text-slate-500 gap-2">
          <i class="fa-solid fa-coins text-emerald-500"></i>
          <span>Transparent earnings & reporting</span>
        </div>
      </div>

    </div>
  </div>
</section>
